import { EmailInput, Modal } from "components";
import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import React from "react";

interface Props {
  bookkeepingId: number;
  initialEmail: server.dto.BookkeepingEmail;
  onClose: () => void;
  onSaved: () => Promise<void>;
}

export const BookkeepingEmailModal = (props: Props) => {
  const isEdit = props.initialEmail != null;
  const defaultInvoiceSetting = serverReference.bookkeepingEmailInvoiceSettings[0].value;

  const [email, setEmail] = React.useState<string>(props.initialEmail?.email ?? "");
  const [invoiceSetting, setInvoiceSetting] = React.useState<server.dto.BookkeepingEmailInvoiceSettings>(
    props.initialEmail?.invoiceSetting ?? defaultInvoiceSetting
  );

  const selectedOption = serverReference.bookkeepingEmailInvoiceSettings.find(o => o.value === invoiceSetting);

  const submit = () => window.CoreApi.Bookkeeping.SetEmail({
    bookkeepingId: props.bookkeepingId,
    email: isEdit ? props.initialEmail.email : email,
    invoiceSetting,
  });

  const onSuccess = async () => {
    await props.onSaved();
    props.onClose();
  };

  return <Modal
    isOpen
    title={RESX.Invoice.SendToAccountingSoftware}
    handleClose={props.onClose}
    width="small"
  >
    <div className="grow1 scrollbox-auto">
      <EditSectionTemplate
        submit={submit}
        noPanels
        onSuccess={onSuccess}
        sections={[{
          key: "emailDetails",
          type: "regular",
          title: RESX.Invoice.SendToAccountingSoftware,
          fields: [{
            key: "email",
            label: RESX.GeneralLabels.Email,
            renderEditNew: () => isEdit
              ? <div className="main-section-template-fields-padding">{props.initialEmail.email}</div>
              : <EmailInput
                value={email}
                onChange={setEmail}
                validatorKey="email"
                emailCanBeBlank={false}
                focusOnMount
                hideErrorLabel
              />,
          }, {
            key: "invoiceSetting",
            label: "Invoice setting",
            renderEditNew: () => 
              <BaseReactSelectDropdown<server.dto.BookkeepingEmailInvoiceSetting, false, server.dto.BookkeepingEmailInvoiceSettings>
                options={serverReference.bookkeepingEmailInvoiceSettings}
                excludeKeys={[]}
                getLabel={o => o.text}
                getValue={o => o.value}
                value={selectedOption}
                onChange={o => setInvoiceSetting(o.value)}
                config={{}}
              />
            ,
          }],
        }]}
      />
    </div>
  </Modal>;
};
